"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_small__and__lightweight__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aa4ca70d-5779-4f41-8b2b-1561bcf05f98",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9d67c1bf-48ab-4c96-990d-c331154199ce",
    x1: 118.71,
    y1: 98.63,
    x2: 143.71,
    y2: 137.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#666",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#666",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "small-and-lightweight-hi-dark"), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,21.51",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,21.51",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 192,
    height: 192,
    transform: "translate(192 192.5) rotate(180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,126.61a158.79,158.79,0,0,1-38-4.73,4,4,0,1,1,2-7.76c9.35,2.39,33.84,7.39,59.25,2.29,31.16-6.25,53-25.25,65-56.47a4,4,0,0,1,7.47,2.87c-13,34-36.88,54.62-70.9,61.44A126.2,126.2,0,0,1,57,126.61Z",
    transform: "translate(0 -0.5)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.72,60.82c-13,33.94-36.88,54.61-70.9,61.44A127,127,0,0,1,57,124.62a158.14,158.14,0,0,1-38-4.74A4,4,0,0,1,16.14,117l0,0A4,4,0,0,0,19,121.88a158.79,158.79,0,0,0,38,4.73,126.2,126.2,0,0,0,24.83-2.36c34-6.82,57.88-27.49,70.9-61.44a4,4,0,0,0,.12-2.45C152.8,60.51,152.77,60.67,152.72,60.82Z",
    transform: "translate(0 -0.5)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2,155.29",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.81,121.78,64.12,83.47A90.11,90.11,0,0,1,62.62,110,172.68,172.68,0,0,0,82.85,69s5.77,13.5,3.77,25a25.72,25.72,0,0,0,7.5-13.86c16.82-4.06,35.86-14.87,50-46,4.48-9.86,10.33-13.67,16.66-13.66,0,0,15.34-1,15.34,33,0,21.22-9.78,71.59-65,98a116,116,0,0,0,23,8c-35.5.68-66-18.47-66-18.47s8.5,17.49,21,27.49c-40-13-52.31-46.72-52.31-46.72",
    transform: "translate(0 -0.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.12,53.5c0-26.36-9.21-31.68-13.36-32.74C147.91,121.58,71.31,125.61,37,121.47l-.22.31S49.12,155.5,89.12,168.5c-12.5-10-21-27.49-21-27.49s30.5,19.15,66,18.47a116,116,0,0,1-23-8C166.34,125.09,176.12,74.72,176.12,53.5Z",
    transform: "translate(0 -0.5)",
    fill: "url(#9d67c1bf-48ab-4c96-990d-c331154199ce)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.13,142.19l-2-1.18-1.26-3.42,1.26.79s24.7,15.5,55.52,18.11c3.12,1,6.67,2.11,10.48,3-30.07.58-56.55-13.08-63.95-17.26",
    transform: "translate(0 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.84,121.56l-.81-.09-.22.31S49.12,155.5,89.12,168.5a51.54,51.54,0,0,1-4.78-4.35A85.5,85.5,0,0,1,37.84,121.56Z",
    transform: "translate(0 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.88,150.1c52.79-26.71,62.24-75.74,62.24-96.6,0-.44,0-.86,0-1.29-.4,21.93-10.89,70.79-65,96.62l-2.63,1.27,2.63,1.36Z",
    transform: "translate(0 -0.5)"
  })));
}

var _default = ic_small__and__lightweight__dark;
exports.default = _default;